import { getCustomSearchCards, type DashboardLayout } from '@edge/spark/io-dashboards'
import { LDFlagSet } from 'launchdarkly-react-client-sdk'

const cardCatalog: DashboardLayout = {
    id: 'f71ddbb4-5f90-4448-86d8-2aba3bcbbed2',
    name: 'CardCatalog',
    cards: [],
}

export const getCardCatalog = (flags: LDFlagSet): DashboardLayout => ({
    ...cardCatalog,
    cards: getCustomSearchCards(flags),
})

export default getCardCatalog
